import React from "react";

export default function Contact() {
  return (
    <div className="agn-cta-light">
      <style>{`
 
        .agn-cta-light {
          padding: var(--section-padding);
          background: #ffffff;
          position: relative;
          overflow: hidden;
        }

        .cta-pattern {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: radial-gradient(rgba(var(--theme-color-rgb), 0.1) 1px, transparent 1px);
          background-size: 30px 30px;
          opacity: 0.5;
          z-index: 0;
        }

        .cta-container {
          position: relative;
          z-index: 1;
          text-align: center;
        }

        .cta-main-title {
          font-family: var(--font-primary);
          font-size: var(--h2-size);
          font-weight: var(--h2-weight);
          color: #111111;
          margin-bottom: var(--margin-title);
          letter-spacing: -0.04em;
          line-height: var(--lh-tight);
        }

        .cta-main-title span {
          color: var(--theme-color);
        }

        .reward-grid-light {
          display: flex;
          justify-content: center;
          gap: 30px;
          margin-bottom: 60px;
          flex-wrap: wrap;
        }

        .reward-card-light {
          flex: 1;
          min-width: 320px;
          max-width: 500px;
          background: #ffffff;
          border-radius: 40px;
          padding: 45px;
          text-align: left;
          border: 1px solid rgba(0, 0, 0, 0.05);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
          transition: all 0.5s cubic-bezier(0.2, 1, 0.3, 1);
          position: relative;
        }

        .reward-card-light:hover {
          transform: translateY(-15px);
          box-shadow: 0 30px 60px rgba(var(--theme-color-rgb), 0.12);
          border-color: rgba(var(--theme-color-rgb), 0.3);
        }

        .reward-card-light::before {
          content: '';
          position: absolute;
          left: 0;
          top: 40px;
          width: 5px;
          height: 30px;
          background: var(--theme-color);
          border-radius: 0 10px 10px 0;
        }

        .reward-card-light h5 {
          font-family: var(--font-primary);
          font-size: 1.25rem;
          font-weight: 800;
          color: #111111;
          margin-bottom: 25px;
          line-height: 1.4;
        }

        .cta-list-light {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .cta-list-light li {
          display: flex;
          align-items: center;
          gap: 15px;
          font-family: var(--font-secondary);
          color: #444444;
          margin-bottom: 15px;
          font-weight: 600;
          font-size: var(--small-size);
        }

        .cta-list-light li i {
          width: 24px;
          height: 24px;
          background: rgba(var(--theme-color-rgb), 0.1);
          color: var(--theme-color);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.8rem;
          flex-shrink: 0;
        }

        .cta-bottom-section {
          margin-top: 80px;
          background: #fcfcfc;
          border-radius: 50px;
          padding: 60px;
          border: 1px solid rgba(0,0,0,0.03);
        }

        .cta-bottom-section h2 {
          font-family: var(--font-primary);
          font-size: 2.2rem;
          font-weight: 900;
          color: #111111;
          margin-bottom: 25px;
        }

        .cta-bottom-section p {
          font-family: var(--font-secondary);
          font-size: var(--body-size);
          color: #666;
          margin-bottom: 35px;
        }

        .cta-benefit-row {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 20px;
          margin-bottom: 45px;
        }

        .cta-benefit-pill {
          font-family: var(--font-primary);
          background: #ffffff;
          padding: 12px 25px;
          border-radius: 100px;
          font-weight: 700;
          color: #333;
          font-size: 0.95rem;
          display: flex;
          align-items: center;
          gap: 10px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.03);
          border: 1px solid rgba(0,0,0,0.05);
          transition: all 0.3s ease;
        }

        .cta-benefit-pill:hover {
          border-color: var(--theme-color);
          color: var(--theme-color);
          transform: translateY(-3px);
        }

        .cta-benefit-pill i {
          color: var(--theme-color);
        }

        .modern-btn {
          font-family: var(--font-primary);
          display: inline-flex;
          align-items: center;
          gap: 15px;
          background: var(--theme-color);
          color: #ffffff;
          padding: 20px 50px;
          border-radius: 100px;
          font-weight: 800;
          font-size: 1.2rem;
          text-decoration: none !important;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          box-shadow: 0 15px 35px rgba(var(--theme-color-rgb), 0.3);
        }

        .modern-btn:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 0 20px 45px rgba(var(--theme-color-rgb), 0.4);
          color: #ffffff;
        }

        .modern-btn .btn-icon {
          width: 35px;
          height: 35px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.4s ease;
        }

        .modern-btn:hover .btn-icon {
          transform: rotate(45deg);
        }

        @media (max-width: 991px) {
          .cta-bottom-section {
            padding: 40px 20px;
          }
        }
      `}</style>

      <div className="cta-pattern"></div>

      <div className="container cta-container">
        {/* <h1 className="cta-main-title">
          Royalty Club & <span>Leadership Rewards
          </span>
        </h1> */}

        {/* <div className="reward-grid-light">
          <div className="reward-card-light">
            <h5>Grow your network and unlock leadership ranks:
            </h5>
            <ul className="cta-list-light">
              <li><i className="fa-solid fa-check"></i>Sales Manager – 2% distribution
              </li>
              <li><i className="fa-solid fa-check"></i> Branch Manager – 1.5%
              </li>
              <li><i className="fa-solid fa-check"></i> Zonal Manager – 1%
              </li>
              <li><i className="fa-solid fa-check"></i> Regional Manager – 0.5%
              </li>
            </ul>
          </div>

          <div className="reward-card-light">
            <h5>Business Reward System
            </h5>
            <ul className="cta-list-light">
              <li><i className="fa-solid fa-check"></i> Earn $2.5 per pair</li>
              <li><i className="fa-solid fa-check"></i> Daily cap: $50
              </li>
              <li><i className="fa-solid fa-check"></i>No admin deductions
              </li>
            </ul>
          </div>
        </div> */}

        <div className="cta-bottom-section">
          <h2>Unlock the Power of Structured Financial Growth
          </h2>
          <p>Join AGN and experience:
          </p>

          <div className="cta-benefit-row">
            <div className="cta-benefit-pill">
              <i className="fa-solid fa-bolt"></i> Passive income opportunities

            </div>
            <div className="cta-benefit-pill">
              <i className="fa-solid fa-cube"></i> Asset-backed financial models

            </div>
            <div className="cta-benefit-pill">
              <i className="fa-solid fa-chart-line"></i>Scalable earning potential

            </div>
          </div>

          <a href="#" className="modern-btn">
            <span>Start Your Journey</span>
            <div className="btn-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
